// Business Units settings merged into the combined "Trades & Business Units"
// page. Kept as a redirect so existing deep links to /business-units don't 404.
// This is the INDEX route (exact /business-units only) so it does not swallow
// child routes like /business-units/$id (the per-BU branding editor).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/business-units/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/trades', replace: true });
  },
});
